import { motion } from "framer-motion";

const ROWS = 6;
const COLS = 6;
const DOT_SIZE = 6;
const GAP = 24;

export default function DotsGrid({ color = "#187672", className = "" }) {
  const dots = [];

  for (let row = 0; row < ROWS; row++) {
    for (let col = 0; col < COLS; col++) {
      // Diagonal desde inferior-izquierda → superior-derecha
      const diagonal = (ROWS - 1 - row) + col;
      const delay = 0.5 + diagonal * 0.06;

      dots.push(
        <motion.circle
          key={`${row}-${col}`}
          cx={col * GAP + DOT_SIZE}
          cy={row * GAP + DOT_SIZE}
          r={DOT_SIZE / 2}
          fill={color}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            delay,
            duration: 0.4,
            type: "spring",
            stiffness: 300,
            damping: 12,
          }}
        />
      );
    }
  }

  const width = (COLS - 1) * GAP + DOT_SIZE * 2;
  const height = (ROWS - 1) * GAP + DOT_SIZE * 2;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      aria-hidden="true"
    >
      {dots}
    </svg>
  );
}
